import { DIAGRAM_SERIES_GROUP_IDS } from '@/features/time-series-chart/config/seriesConfig';
import type { DiagramSeriesGroup } from '@/features/time-series-chart/types/DiagramSeries.types';
import type { SeriesResponseDto } from '@/generated/model';

/** The measure channels response lists each group under its own key; the UI needs them as one ordered list. */
export function mapDiagramSeriesMetadata(response: SeriesResponseDto): DiagramSeriesGroup[] {
  return DIAGRAM_SERIES_GROUP_IDS.map((group) => ({
    id: group,
    series: response[group].map((series) => ({ ...series, group })),
  }));
}
